<template>
  <div class="confirmation" v-if="!disabled">
    <div v-if="lr != 0 && payment.method == 'credit_card'" class="alert-purchase-refused pulse-alert-purchase-refused">
      <h3 class="text-center">Tentativa de pagamento não foi bem-sucedida</h3>
      <p>
        <strong>Descrição:</strong><br/>
        <span> {{descriptionLr}}</span>
      </p>

      <p>
        <strong>O que fazer agora?</strong><br/>
        <span> Verifique os dados do cartão ou tente outro método de pagamento.</span>
      </p>

      <p>
        <span>
          Em breve nossa equipe entrará em contato com você via Whatsapp para auxiliar no processo de adesão.
        </span>
      </p>
    </div>

    <h2 class="confirmation-title">Confirme abaixo os dados para finalizar a sua compra:</h2>

    <section class="section" v-if="planLine">
      <h3 class="section-header">
        <b-icon icon="cart"></b-icon>
        <span>Item do contrato</span>
      </h3>

      <div class="fields-grid">
        <div class="field">
          <span class="field-label">Plano selecionado</span>
          <span class="field-value">{{ planLine }}</span>
        </div>

        <template v-if="isAnnual && contractYears > 0">
          <div class="field">
            <span class="field-label">Tempo de contrato</span>
            <span class="field-value">{{ contractYears }} {{ contractYears > 1 ? 'anos' : 'ano' }} de acesso</span>
          </div>

          <div class="field">
            <span class="field-label">Usuário master</span>
            <span class="field-value">
              1 un. de {{ contractYears }} {{ contractYears > 1 ? 'anos' : 'ano' }} de acesso por
              <span v-if="discount" class="old-price">{{ formatRealCurrent(getPlan.value * contractYears) }}</span>
              {{ formatRealCurrent((getPlan.value - getDiscount) * contractYears) }}
            </span>
          </div>

          <div class="field" v-if="billingData.precoCompraUsuariosSubordinados > 0">
            <span class="field-label">Usuário(s) subordinado(s)</span>
            <span class="field-value">
              {{ billingData.numberAccesses }} un. de {{ contractYears }} {{ contractYears > 1 ? 'anos' : 'ano' }} de acesso por
              {{ formatRealCurrent(billingData.precoCompraUsuariosSubordinados) }}
            </span>
          </div>

          <div class="field" v-if="isCreditCard && installments > 1">
            <span class="field-label">Parcelamento</span>
            <span class="field-value">
              {{ installments }}x de {{ formatRealCurrent(totalToPay / installments) }}
              <template v-if="installments > 3">(com juros)</template>
              <template v-else>(sem juros)</template>
            </span>
          </div>

          <div class="field">
            <span class="field-label">Total a pagar</span>
            <span class="field-value total-value">{{ formatRealCurrent(totalToPay) }}</span>
          </div>
        </template>
      </div>
    </section>

    <div class="groups" v-if="billingData">
      <section class="section">
        <h3 class="section-header">
          <b-icon icon="person"></b-icon>
          <span>Dados do contratante</span>
        </h3>
        <div class="field" v-if="billingData.name">
          <span class="field-label">Nome</span>
          <span class="field-value">{{ billingData.name }}</span>
        </div>
        <div class="field" v-if="billingData.document">
          <span class="field-label">CPF</span>
          <span class="field-value">{{ billingData.document }}</span>
        </div>
        <div class="field" v-if="billingData.email">
          <span class="field-label">Email</span>
          <span class="field-value">{{ billingData.email }}</span>
        </div>
        <div class="field" v-if="billingData.companyName">
          <span class="field-label">Nome da empresa</span>
          <span class="field-value">{{ billingData.companyName }}</span>
        </div>
        <div class="field" v-if="billingData.cnpj">
          <span class="field-label">CNPJ</span>
          <span class="field-value">{{ billingData.cnpj }}</span>
        </div>
        <div class="field" v-if="billingData.stateRegister">
          <span class="field-label">Inscrição estadual</span>
          <span class="field-value">{{ billingData.stateRegister }}</span>
        </div>
        <div class="field" v-if="billingData.cityRegister">
          <span class="field-label">Inscrição municipal</span>
          <span class="field-value">{{ billingData.cityRegister }}</span>
        </div>
      </section>

      <section class="section">
        <h3 class="section-header">
          <b-icon icon="geo-alt"></b-icon>
          <span>Endereço do contratante</span>
        </h3>
        <div class="fields-grid">
          <div class="field" v-if="billingData.address.street && billingData.address.number">
            <span class="field-label">Rua</span>
            <span class="field-value">{{ billingData.address.street }}, {{ billingData.address.number }}</span>
          </div>
          <div class="field" v-if="billingData.address.complement">
            <span class="field-label">Complemento</span>
            <span class="field-value">{{ billingData.address.complement }}</span>
          </div>
          <div class="field" v-if="billingData.address.neighborhood">
            <span class="field-label">Bairro</span>
            <span class="field-value">{{ billingData.address.neighborhood }}</span>
          </div>
          <div class="field" v-if="billingData.address.city">
            <span class="field-label">Cidade</span>
            <span class="field-value">{{ billingData.address.city }}</span>
          </div>
          <div class="field" v-if="billingData.address.state">
            <span class="field-label">Estado</span>
            <span class="field-value">{{ billingData.address.state }}</span>
          </div>
          <div class="field" v-if="billingData.address.cep">
            <span class="field-label">CEP</span>
            <span class="field-value">{{ billingData.address.cep }}</span>
          </div>
        </div>
      </section>
    </div>

    <div class="payment" v-if="payment">
      <h2>Dados de Pagamento</h2>
      <span v-if="payment.method">
        <strong>Método: </strong>
        {{methods[payment.method]}}
      </span>
      <span class="payment-method-notes">
        <template v-if="payment.method == 'credit_card'">
         <span>
          O acesso à plataforma HO Fácil Web é liberado automaticamente assim que o pagamento
          é aprovado pela operadora do cartão. Esse processo pode levar até <strong>15 minutos</strong>.
         </span>
        </template>
        <template v-else>
          <strong >
            Pagamento via PIX:
          </strong>
          <span>
            O acesso à plataforma HO Fácil Web é liberado automaticamente em até 30 minutos após a confirmação do pagamento.
          </span><br/><br/>

          <strong>Pagamento via boleto bancário:</strong>
          <span>
            O acesso é liberado automaticamente após a compensação do pagamento, que pode levar de <strong>24 a 72 horas</strong>, dependendo do banco.
          </span><br/>
          <span>
            Se o boleto for pago por <strong>agendamento</strong>, o prazo de até 72 horas começa a contar a partir da <strong>data efetiva do pagamento</strong>.
          </span>
        </template>
      </span>
    </div>


    <div class="buttons">
      <base-button
        class='nav-btn'
        dark
        @click="$emit('back-step')"
      >
        Voltar
      </base-button>
      <base-button
        class='nav-btn'
        @click="submitCheckout"
        :disabled="disabled"
      >
        Finalizar Compra
      </base-button>
    </div>
  </div>
  <div class="process-purchase" v-else>
    <div class='d-flex justify-content-end flex-column align-items-center'>
      <div class='mb-3'>
        <h5 v-if="tentativa === 1"><strong>Aguarde enquanto estamos tentando processar seu pagamento.</strong></h5>
        <h5 v-else-if="tentativa === 2"><strong>Estamos tendo lentidão ao processar pagamento, por favor, aguarde mais um pouco.</strong></h5>
        <h5 v-else><strong>Por favor, aguarde mais um pouco</strong></h5>
      </div>

      <div >
        <b-spinner style="width: 4rem; height: 4rem; font-size: 30px" variant="info"></b-spinner>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { getLr } from '../../../../utils/getLr'
import { formatRealCurrent } from '@/utils/format'

export default {
  name: 'Confirmation',
  computed: {
    ...mapGetters('checkout2', {
      payment: 'getPayment',
      billingData: 'getBillingData',
      getPlan: 'getPlan',
      getDiscount: 'getDiscount',
      promotion: 'getPromotion',
    }),
    ...mapGetters('promocodes', {
      discount: 'discount',
    }),
    user() {
      return this.$store.getters['user/current']
    },
    planLine() {
      const plan = this.getPlan || {}
      if (!plan.value) {
        return ''
      }
      const isSubscription = plan.method === 'subscription'
      const label = isSubscription ? 'Plano Mensal' : 'Plano Anual'
      const suffix = isSubscription ? 'por recorrência' : 'por ano'
      return `${label} - ${formatRealCurrent(plan.value)} ${suffix}`
    },
    isAnnual() {
      const plan = this.getPlan || {}
      return !!plan.value && plan.method !== 'subscription'
    },
    contractYears() {
      return this.billingData ? parseInt(this.billingData.contractTimeYears) : 0
    },
    installments() {
      return this.payment && this.payment.data ? Number(this.payment.data.installments) : 1
    },
    isCreditCard() {
      return this.payment && this.payment.method === 'credit_card'
    },
    finalPrice() {
      const plan = this.getPlan || {}
      const years = parseInt(this.billingData.contractTimeYears)
      const base = (parseFloat(plan.value) * years) + Number(this.billingData.precoCompraUsuariosSubordinadosSemDesconto)
      if (this.installments <= 3) {
        return base
      }
      return base * Math.pow(1 + this.taxaJuros / 100, this.installments)
    },
    priceForPromotion() {
      const plan = this.getPlan || {}
      const years = parseInt(this.billingData.contractTimeYears)
      let discount = this.discount
      if (this.promotion && this.promotion.code === 'RENEW' && this.discount) {
        discount = (parseFloat(discount) * parseFloat(plan.value)) / 100
      }
      if (!discount) {
        discount = 0
      }
      const base = ((parseFloat(plan.value) - parseFloat(discount)) * years) + Number(this.billingData.precoCompraUsuariosSubordinados)
      if (this.installments <= 3) {
        return base
      }
      return base * Math.pow(1 + this.taxaJuros / 100, this.installments)
    },
    totalToPay() {
      return this.discount ? this.priceForPromotion : this.finalPrice
    },
  },
  data(){
    return {
      disabled: false,
      descriptionLr: 'ssssssssssssssssssssssss',
      lr: 0,
      tentativa: 0,
      invoice: Object,
      charge: Object,
      taxaJuros: 1.49,
      methods: {
        'credit_card': 'Cartão de crédito',
        'bank_slip': 'Boleto bancário e PIX',
      },
    }
  },
  methods: {
    ...mapActions('checkout2', {
      handleSubmitCheckout: 'handleSubmitCheckout',
      handleSetAlertDetails: 'handleSetAlertDetails',
      handleResetAlertDetails: 'handleResetAlertDetails',
      handleResetSteps: 'handleResetSteps',
      handleResetPayment: 'handleResetPayment',
      handleResetBillingData: 'handleResetBillingData',
      handleResetPromotion: 'handleResetPromotion',
    }),
    ...mapActions('userActionLogs', {
      createUserActionLogs: 'createUserActionLogs',
    }),
    ...mapActions('userPlans', {
      handleSetDataRedirection: 'handleSetDataRedirection'
    }),
    formatRealCurrent,
    async submitCheckout(){
      try{
        this.disabled = true
        this.tentativa++;
        const response = await this.handleSubmitCheckout()
        this.lr = 0;
        if (response.errors) {
          const errorRaw = response.errors
          let error = errorRaw || 'Dados inválidos, verifique e tente novamente!'

          if(errorRaw['payer.address.zip_code'] || errorRaw['zip_code']){
            error = 'CEP inválido, verifique e tente novamente!'
          }

          if(errorRaw['payer.cpf_cnpj'] || errorRaw['cpf_cnpj']){
            error = 'CPF/CNPJ inválido, verifique e tente novamente!'
          }

          if(errorRaw['plan_identifier']){
            error = 'Plano inválido, verifique e tente novamente!'
          }

          if(errorRaw['token'] || errorRaw === 'Esse token já foi usado.' || errorRaw === 'This token has already been used'){
            error = 'Por favor preencha os dados do cartão novamente'
            this.$emit('back-step')
          }

          await this.handleSetAlertDetails({
            open: true,
            type: 'danger',
            message: error
          })
          this.disabled = false;
        } else {
          const {bankSlip, invoice, charge, sucess, base64Invoice, planId} = response
          this.charge = charge
          this.invoice = invoice
          if (sucess) {
            if (this.user && this.user.role !== 'admin') {
              const log = {
                action: 'FINALIZOU_COMPRA'
              }
              await this.createUserActionLogs(log)
            }

            if(this.payment.method == 'bank_slip' || (invoice && invoice.status && invoice.status == 'paid')){
              await this.handleSetAlertDetails({
                open: true,
                type: 'success',
                message: 'Pedido efetivado com sucesso!'
              })
              let urlInvoice = bankSlip
              if(!urlInvoice && invoice && invoice.secure_url){
                urlInvoice = invoice.secure_url
              }

              if (urlInvoice) {
                window.open(urlInvoice, '_blank', "noopener,noreferrer")
              }

              if (base64Invoice) {
                const excel = `data:application/pdf;base64,${base64Invoice}`;
                const link = document.createElement("a");
                link.href = excel;
                link.setAttribute("download", `fatura.pdf`);
                document.body.appendChild(link);
                link.click();
              }

              setTimeout(async () => {
                if (planId) {
                  await this.handleSetDataRedirection(planId)
                }
                window.location.replace('http://hofacilweb.com.br/?page_id=249')
              }, 100)
              this.disabled = false;
              return
            }

            let lr = null;
            if (charge && charge.LR){
              lr = charge.LR;
            } else if (invoice && invoice.lr){
              lr = invoice.lr;
            } else if (invoice && invoice.LR){
              lr = invoice.LR;
            } else if (invoice && invoice.credit_card_transaction && invoice.credit_card_transaction.lr){
              lr = invoice.credit_card_transaction.lr;
            } else if (invoice && invoice.credit_card_transaction && invoice.credit_card_transaction.LR){
              lr = invoice.credit_card_transaction.LR;
            }
            if(!lr && invoice && invoice.logs && invoice.logs.length > 0){
              for (const log of invoice.logs) {
                const {notes} = log
                if(!notes){
                  continue
                }
                const notesSplit = notes.toString().split(',')

                if(!notesSplit || notesSplit.length <= 0){
                  continue
                }

                const lrLog = notesSplit.find(x => x && x.toString().toUpperCase().trim().includes('LR'))
                if(!lrLog){
                  continue
                }

                const lrLogSplit = lrLog.split(':')

                if(!lrLogSplit || lrLogSplit.length <= 1){
                  continue
                }
                lr = lrLogSplit[1].trim()
              }
            }
            this.lr = lr
            this.descriptionLr = getLr(lr)
          } else {
            await this.handleSetAlertDetails({
              open: true,
              type: 'danger',
              message: 'Não foi possível processar seu pagamento, tente novamente mais tarde!!'
            })
          }
          this.disabled = false;
        }
      } catch(e) {
        if(this.tentativa < 3) {
          setTimeout(async () => {
            await this.submitCheckout();
          }, 22500)
        } else {
          this.disabled = false;
          this.tentativa = 0;
          await this.handleSetAlertDetails({
            open: true,
            type: 'danger',
            message: 'Não foi possível processar seu pagamento, tente novamente mais tarde!!!'
          })
        }
      } finally {
        //this.disabled = false;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.loading-spinner{
  width: 2.5rem;
  height: 2.5rem;
  margin: -15px 0 0 10px;
}
.confirmation {
  display: flex;
  flex-direction: column;
  gap: 20px;

  .confirmation-title {
    color: #04A8F3;
    font-size: 22px;
    font-weight: 700;
  }

  h2 {
    font-size: 22px;
    font-weight: 700;
  }

  .section {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .section-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0;
    padding-bottom: 8px;
    border-bottom: 1px solid #e2e6ee;
    color: #3a4256;
    font-size: 14px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;

    .b-icon {
      font-size: 18px;
      color: #6b7488;
    }
  }

  .fields-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px 24px;

    @media only screen and (max-width: 720px) {
      grid-template-columns: 1fr;
    }
  }

  .field {
    display: flex;
    flex-direction: column;
    gap: 2px;

    .field-label {
      font-size: 12px;
      font-weight: 400;
      text-transform: uppercase;
      letter-spacing: 0.04em;
      color: #8a93a6;
    }

    .field-value {
      font-size: 15px;
      font-weight: 700;
      color: #1c2439;

      .old-price {
        text-decoration: line-through;
        color: #bc0000;
        font-weight: 400;
        margin-right: 6px;
      }

      &.total-value {
        font-size: 18px;
        color: #04A8F3;
      }
    }
  }

  .groups {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;

    @media only screen and (max-width: 720px) {
      grid-template-columns: 1fr;
    }
  }

  .payment {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .payment-method-notes {
      background: #eef1f6;
      border-radius: 8px;
      padding: 16px 18px;
      font-size: 15px;
      color: #1c2439;
    }
  }

  .buttons {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    margin-top: 24px;

    .nav-btn {
      min-width: 140px;
      padding: 12px 20px;
    }
  }

  .alert-purchase-refused{
    margin-top: 10px;
    background: rgba(248, 215, 218, 1);
    padding: 10px 15px;
    h3{
      font-weight: 700;
      font-size: 20px;
      color: #721C24;
    }
    strong{
      font-weight: 700;
      font-size: 16px;
      color: #262626;
    }
    span{
      font-weight: 400;
      font-size: 14px;
      color: #721C24;
    }
  }
}

.process-purchase{
  height: 480px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pulse-alert-purchase-refused {
  -webkit-animation: pulse-alert 1s infinite cubic-bezier(0.66, 0, 0, 1);
  -moz-animation: pulse-alert 1s infinite cubic-bezier(0.66, 0, 0, 1);
  -ms-animation: pulse-alert 1s infinite cubic-bezier(0.66, 0, 0, 1);
  animation: pulse-alert 1s infinite cubic-bezier(0.66, 0, 0, 1);
  box-shadow: 0 0 0 0 #721C24;
  border-radius: 3px;
  margin-bottom: 3px!important;
  margin-top: 3px!important;
}



@-webkit-keyframes pulse-alert {
  to {
    box-shadow: 0 0 0 8px rgba(232, 76, 61, 0);
  }
}

@-moz-keyframes pulse-alert {
  to {
    box-shadow: 0 0 0 8px rgba(232, 76, 61, 0);
  }
}

@-ms-keyframes pulse-alert {
  to {
    box-shadow: 0 0 0 8px rgba(232, 76, 61, 0);
  }
}

@keyframes pulse-alert {
  to {
    box-shadow: 0 0 0 8px rgba(232, 76, 61, 0);
  }
}

</style>
